/* jshint ignore:start */
import React from 'react';
import './ScrollToTop.css';

const ScrollToTop = () => {
    return (
      <div className="scrollTop">
        <svg
          className="bi bi-arrow-up-circle-fill"
          width="2em"
          height="2em"
          viewBox="0 0 16 16"
          fill="currentColor">
          <path
            fillRule="evenodd"
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-10.646.354a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 6.207V11a.5.5 0 0 1-1 0V6.207L5.354 8.354z"
          />
        </svg>
      </div>
    );
}

export default ScrollToTop;
